import React from 'react';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';

type Props = {
  title: string;
  description: string;
};

export const ChatOnboardingNudge: React.FC<Props> = ({
  title,
  description,
}) => {
  return (
    <Box
      mx='m'
      mb='s'
      padding='m'
      backgroundColor='black'
      borderRadius='xs'
      flexDirection='row'
      alignItems='center'
      style={{
        shadowColor: 'black',
        shadowOpacity: 0.05,
        shadowOffset: { width: 0, height: 5 },
        shadowRadius: 25,
        elevation: 5,
      }}>
      <Box
        width={40}
        height={40}
        borderRadius='xxl'
        backgroundColor='greenDark'
        alignItems='center'
        justifyContent='center'
        flexShrink={0}>
        <Icon name='Hash' variant='m' color='greenBrand' />
      </Box>
      <Box flex={1} marginLeft='m'>
        <Text variant='labelEmphasizedNudgeTitle' marginBottom='xxs'>
          {title}
        </Text>
        <Text variant='webBodyHintSubline' color='white'>
          {description}
        </Text>
      </Box>
    </Box>
  );
};
